import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map } from 'rxjs';

/**
 * Guard for routes accessible by guests (unauthenticated users).
 * initialize() in BroadcastChannelService handles org/app info loading — no duplicate work here.
 */
export const guestGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  return authService.check().pipe(map(() => true));
};
